import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Collapse, IconButton, Modal } from "@mui/material";
import "./ModalTranscription.css";
import MessageListTranscription from "./MessageListTranscription";
import Loader from "../Components/Loader";
import { getSpeechToText } from "../Store/Actions/CallAction";

export default function ModalTranscription({ recMessageID, onClose }) {
  const [isLoading, setIsLoading] = useState(true);
  const [isSummaryCollapsed, setIsSummaryCollapsed] = useState(true);
  const [messages, setMessages] = useState([]);
  const [summary, setSummary] = useState("");

  useEffect(() => {
    recMessageID &&
      getSpeechToText({ recmessageid: recMessageID })
        .then((response) => {
          if (response.status) {
            process.env.NODE_ENV === "development" &&
              console.log("transcription: ", response.data);

            setMessages(response.data.transcript);
            setSummary(response.data.summary);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
            toast.error("Error loading transcription.", { autoClose: 3000 });
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
          toast.error("Error loading transcription.", { autoClose: 3000 });
        });
  }, []);

  return (
    <Modal open onClose={onClose}>
      <div className="modalContainerHistory modal-transcription">
        <div className="header-container">
          <div className="header">
            <h1>Transcription</h1>
            <CloseOutlined className="close-button" onClick={onClose} />
          </div>
        </div>

        <div className="transcription-container">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="summary">
                <header className={isSummaryCollapsed ? "collapsed" : ""}>
                  <p>Summary</p>

                  <IconButton
                    onClick={() =>
                      setIsSummaryCollapsed((prevState) => !prevState)
                    }
                  >
                    <Icon
                      icon={`icon-park:${isSummaryCollapsed ? "up" : "down"}`}
                      width="20"
                      height="20"
                    />
                  </IconButton>
                </header>

                <Collapse in={isSummaryCollapsed} unmountOnExit>
                  <p className="summary-text">{summary}</p>
                </Collapse>
              </div>

              <MessageListTranscription messages={messages} />
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}
